import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

interface SupportContextBannerProps {
  targetLabel: string;
  remainingMs: number;
  expired: boolean;
  onClose: () => void;
  closing?: boolean;
}

function formatRemaining(remainingMs: number): string {
  const total = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function SupportContextBanner({
  targetLabel,
  remainingMs,
  expired,
  onClose,
  closing = false,
}: SupportContextBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-warning/30 bg-warning/10 px-4 py-3">
      <ShieldAlert size={18} className="shrink-0 text-warning" aria-hidden="true" />
      {expired ? (
        <p key="expired" role="alert" className="text-sm text-heading">
          {t("staff.banner.expired")}
        </p>
      ) : (
        <p key="active" className="text-sm text-heading">
          {t("staff.banner.active", { target: targetLabel })}
        </p>
      )}
      {!expired && (
        <span className="rounded-md bg-elevated px-2 py-1 font-mono text-xs text-muted">
          {t("staff.banner.remaining", { time: formatRemaining(remainingMs) })}
        </span>
      )}
      <button
        type="button"
        onClick={onClose}
        disabled={closing}
        className="ml-auto rounded-lg border border-border px-3 py-1.5 text-sm font-medium text-muted hover:bg-elevated hover:text-heading disabled:opacity-60"
      >
        {expired ? t("staff.banner.closeExpired") : t("staff.banner.close")}
      </button>
    </div>
  );
}
